let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dVu8o")).then(() => parcelRequire('4OIqI'));